const Barcode = (props: React.SVGProps<SVGSVGElement>): React.ReactElement => {
    return (
        <svg
            width="19"
            height="19"
            viewBox="0 0 19 19"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <g clipPath="url(#clip0_13_187)">
                <path
                    d="M16.45 18.3499C16.9721 18.3636 17.4789 18.1725 17.862 17.8175C18.2451 17.4624 18.4741 16.9716 18.5 16.45"
                    stroke="currentColor"
                    strokeMiterlimit="10"
                    strokeLinecap="round"
                />
                <path
                    d="M0.640027 16.29C0.610849 16.5514 0.633535 16.816 0.706738 17.0686C0.779941 17.3212 0.902223 17.5569 1.06663 17.7622C1.23104 17.9675 1.43435 18.1383 1.66487 18.2649C1.89539 18.3915 2.14861 18.4714 2.41005 18.5"
                    stroke="currentColor"
                    strokeMiterlimit="10"
                    strokeLinecap="round"
                />
                <path
                    d="M2.54999 0.5C1.99381 0.533575 1.47292 0.783745 1.09904 1.19688C0.725154 1.61002 0.528053 2.15322 0.549993 2.70999"
                    stroke="currentColor"
                    strokeMiterlimit="10"
                    strokeLinecap="round"
                />
                <path
                    d="M18.5 2.70999C18.519 2.14568 18.3142 1.59675 17.9302 1.1828C17.5462 0.768847 17.0142 0.523428 16.45 0.5"
                    stroke="currentColor"
                    strokeMiterlimit="10"
                    strokeLinecap="round"
                />
                <path
                    d="M0.909973 9.15002H18.09"
                    stroke="currentColor"
                    strokeMiterlimit="10"
                    strokeLinecap="round"
                />
                <path
                    d="M5.88002 10.85H3.82002C3.51626 10.85 3.27002 11.0962 3.27002 11.4V14.66C3.27002 14.9637 3.51626 15.21 3.82002 15.21H5.88002C6.18378 15.21 6.43002 14.9637 6.43002 14.66V11.4C6.43002 11.0962 6.18378 10.85 5.88002 10.85Z"
                    fill="currentColor"
                />
                <path
                    d="M12.84 10.85H10.78C10.4762 10.85 10.23 11.0962 10.23 11.4V14.66C10.23 14.9637 10.4762 15.21 10.78 15.21H12.84C13.1437 15.21 13.39 14.9637 13.39 14.66V11.4C13.39 11.0962 13.1437 10.85 12.84 10.85Z"
                    fill="currentColor"
                />
                <path
                    d="M8.26001 15.2C8.19615 15.2027 8.13238 15.1926 8.07248 15.1703C8.01257 15.148 7.95771 15.114 7.91113 15.0702C7.86456 15.0264 7.82719 14.9738 7.80124 14.9154C7.77528 14.857 7.76129 14.7939 7.76001 14.73V11.29C7.76001 11.1574 7.81266 11.0303 7.90643 10.9365C8.0002 10.8427 8.1274 10.79 8.26001 10.79C8.39262 10.79 8.51979 10.8427 8.61356 10.9365C8.70732 11.0303 8.76001 11.1574 8.76001 11.29V14.7C8.76284 14.7665 8.75182 14.8327 8.72769 14.8947C8.70357 14.9566 8.66685 15.0129 8.61984 15.0599C8.57284 15.1069 8.51659 15.1436 8.45465 15.1677C8.39271 15.1919 8.32643 15.2029 8.26001 15.2Z"
                    fill="currentColor"
                />
                <path
                    d="M15.28 15.2C15.2162 15.2027 15.1524 15.1926 15.0925 15.1703C15.0326 15.148 14.9778 15.114 14.9312 15.0702C14.8846 15.0264 14.8472 14.9738 14.8213 14.9154C14.7953 14.857 14.7813 14.7939 14.78 14.73V11.29C14.78 11.1574 14.8327 11.0303 14.9265 10.9365C15.0203 10.8427 15.1474 10.79 15.28 10.79C15.4126 10.79 15.5398 10.8427 15.6336 10.9365C15.7273 11.0303 15.78 11.1574 15.78 11.29V14.7C15.7829 14.7665 15.7719 14.8327 15.7477 14.8947C15.7236 14.9566 15.6869 15.0129 15.6399 15.0599C15.5929 15.1069 15.5366 15.1436 15.4747 15.1677C15.4127 15.1919 15.3464 15.2029 15.28 15.2Z"
                    fill="currentColor"
                />
                <path
                    d="M5.88002 3.88H3.82002C3.51626 3.88 3.27002 4.12625 3.27002 4.43V8.69C3.27002 8.99376 3.51626 9.24 3.82002 9.24H5.88002C6.18378 9.24 6.43002 8.99376 6.43002 8.69V4.43C6.43002 4.12625 6.18378 3.88 5.88002 3.88Z"
                    fill="currentColor"
                />
                <path
                    d="M12.84 3.88H10.78C10.4762 3.88 10.23 4.12625 10.23 4.43V8.69C10.23 8.99376 10.4762 9.24 10.78 9.24H12.84C13.1437 9.24 13.39 8.99376 13.39 8.69V4.43C13.39 4.12625 13.1437 3.88 12.84 3.88Z"
                    fill="currentColor"
                />
                <path
                    d="M8.26001 9.29002C8.19566 9.29135 8.13167 9.27998 8.07172 9.25658C8.01176 9.23317 7.95698 9.19818 7.91055 9.15361C7.86412 9.10904 7.82692 9.05575 7.80109 8.9968C7.77525 8.93784 7.76131 8.87438 7.76001 8.81003V4.40002C7.76001 4.26742 7.81266 4.14023 7.90643 4.04646C8.0002 3.95269 8.1274 3.90002 8.26001 3.90002C8.39262 3.90002 8.51979 3.95269 8.61356 4.04646C8.70732 4.14023 8.76001 4.26742 8.76001 4.40002V8.81003C8.75871 8.87438 8.74474 8.93784 8.7189 8.9968C8.69307 9.05575 8.65587 9.10904 8.60944 9.15361C8.563 9.19818 8.50823 9.23317 8.44827 9.25658C8.38831 9.27998 8.32436 9.29135 8.26001 9.29002Z"
                    fill="currentColor"
                />
                <path
                    d="M15.28 9.15998C15.1626 9.16437 15.0475 9.12639 14.9557 9.05296C14.8639 8.97953 14.8015 8.87555 14.78 8.75999V4.34998C14.773 4.28025 14.7807 4.20982 14.8027 4.14326C14.8247 4.0767 14.8604 4.01551 14.9076 3.96365C14.9547 3.91178 15.0122 3.87041 15.0764 3.84222C15.1406 3.81402 15.2099 3.79963 15.28 3.79998C15.3439 3.7973 15.4077 3.80742 15.4676 3.82972C15.5275 3.85202 15.5823 3.88604 15.6289 3.92982C15.6755 3.9736 15.7128 4.02625 15.7388 4.08466C15.7647 4.14308 15.7788 4.20608 15.78 4.26998V8.67999C15.7787 8.74434 15.7648 8.8078 15.7389 8.86675C15.7131 8.92571 15.6759 8.97899 15.6295 9.02357C15.583 9.06814 15.5283 9.10313 15.4683 9.12653C15.4084 9.14994 15.3444 9.16131 15.28 9.15998Z"
                    fill="currentColor"
                />
            </g>
            <defs>
                <clipPath id="clip0_13_187">
                    <rect width="19" height="19" fill="white" />
                </clipPath>
            </defs>
        </svg>
    )
}

export default Barcode
